import React from 'react';

import EventAgenda from 'buyside/components/presentation/EventPage/EventAgenda/eventAgenda';
import EventDescription from 'buyside/components/presentation/EventPage/EventDescription/eventDescription';
import EventFooter from 'buyside/components/presentation/EventPage/EventFooter/eventFooter';
import EventHeader from 'buyside/components/presentation/EventPage/EventHeader/eventHeader';
import EventSpeakers, {
  Props
} from 'buyside/components/presentation/EventPage/EventSpeakers/eventSpeakers';

// import EventSponsors from 'buyside/components/presentation/EventPage/EventSponsors/eventSponsors';
import PageNavigator from 'buyside/components/presentation/PageNavigator/pageNavigator';

const navigatorItems = [
  { label: 'Description', id: 'description' },
  { label: 'Keynote', id: Props.Keynote },
  { label: 'Stock Pitch', id: Props.StockPitch },
  { label: 'VC Panel', id: Props.VCPanel },
  { label: 'Agenda', id: 'agenda' }
];

const EventPage: React.FC<{
  contestId?: string;
  isLoggedIn: boolean;
}> = ({ isLoggedIn }) => {
  return (
    <>
      <EventHeader isLoggedIn={isLoggedIn} />
      <PageNavigator items={navigatorItems} />
      <EventDescription isLoggedIn={isLoggedIn} />
      <EventSpeakers type={Props.Keynote} />
      <EventSpeakers type={Props.StockPitch} />
      <EventSpeakers type={Props.VCPanel} />
      <EventAgenda isLoggedIn={isLoggedIn} />
      {/* {contestId && <EventSponsors contestId={contestId} />} */}
      <EventFooter />
    </>
  );
};

export default EventPage;
